import * as React from 'react';
import { useSelector } from 'react-redux';
import { PhonesContainer } from 'shared/containers/AsideContacts/PhonesContainer';
import { SendMessageButtonContainer } from 'shared/containers/AsideContacts/SendMessageButton';
import { BookButtonContainer } from 'shared/containers/BookButtonContainer';
import { selectShouldRenderContacts } from 'shared/selectors/contacts/selectShouldRenderContacts';
import { selectDailyrentActionType } from 'shared/selectors/dailyrentActionType';
import { EActionType } from 'shared/types/dailyrent';

import { DailyrentViewBookingRequestButtonContainer } from '../DailyrentViewBookingRequestButtonContainer';
import { OnlineBookingBookButtonContainer } from '../OnlineBookingBookButtonContainer';
import { OnlineBookingCheckDatesButtonContainer } from '../OnlineBookingCheckDatesButtonContainer';

interface IWrapperProps {
  children: React.ReactNode;
}

const Wrapper: React.FC<IWrapperProps> = ({ children }) => {
  return <div data-testid="DailyrentActionButtonsContainer">{children}</div>;
};

export const DailyrentActionButtonsContainer = () => {
  const shouldRenderContacts = useSelector(selectShouldRenderContacts);
  const actionType = useSelector(selectDailyrentActionType);

  switch (true) {
    case actionType === EActionType.OtaBooking: {
      return (
        <Wrapper>
          <OnlineBookingBookButtonContainer />
          <SendMessageButtonContainer />
        </Wrapper>
      );
    }

    case actionType === EActionType.OtaCheckDates: {
      return (
        <Wrapper>
          <OnlineBookingCheckDatesButtonContainer />
          <SendMessageButtonContainer />
        </Wrapper>
      );
    }

    case actionType === EActionType.BookingRequestView: {
      return (
        <Wrapper>
          <DailyrentViewBookingRequestButtonContainer />
          <SendMessageButtonContainer />
        </Wrapper>
      );
    }

    case actionType === EActionType.PartnerBooking:
    case actionType === EActionType.PartnerCheckDates: {
      return <BookButtonContainer />;
    }

    case actionType === EActionType.Chat: {
      return (
        <Wrapper>
          <SendMessageButtonContainer />
        </Wrapper>
      );
    }

    default: {
      return (
        <Wrapper>
          {shouldRenderContacts && <PhonesContainer />}
          <SendMessageButtonContainer />
        </Wrapper>
      );
    }
  }
};
